import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';
import { Observable } from 'rxjs';

export interface GenericDialogButton {
  label: string;
  value: any;
  action: Function;
}

@Injectable({
  providedIn: 'root',
})
export class GenericDialogService {
  constructor(private dialog: MatDialog) {}

  public displayDialog(title: string, body: string, buttons: GenericDialogButton[]): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    if (title) {
      dialogConfig.height = '200px';
    } else {
      dialogConfig.height = '150px';
    }
    dialogConfig.width = '300px';
    // dialogConfig.panelClass = 'paddingless-dialog';
    dialogConfig.data = {
      title: title,
      body: body,
      buttons: buttons,
    };

    let dialogRef = this.dialog.open(GenericDialogComponent, dialogConfig);

    return dialogRef.afterClosed();
  }

  public annotationInfoDialog(body: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      body: body,
    };

    let dialogRef = this.dialog.open(GenericDialogComponent, dialogConfig);

    return dialogRef.afterClosed();
  }

  public getOkCancelButton(okAction?: Function, cancelAction?: Function): GenericDialogButton[] {
    return [
      {
        label: 'Ok',
        value: true,
        action: okAction || (() => {}),
      },
      {
        label: 'Cancel',
        value: false,
        action: cancelAction || (() => {}),
      },
    ];
  }

  public getOkButton(okAction?: Function): GenericDialogButton[] {
    return [
      {
        label: 'Ok',
        value: true,
        action: okAction || (() => {}),
      },
    ];
  }
}
